import { inject, provideAppInitializer } from '@angular/core';
import { Device } from '@capacitor/device';
import { TranslocoService } from '@jsverse/transloco';
import { AccountRepository } from '@timechef/features/account/state';
import { lastValueFrom } from 'rxjs';
import { DefaultLanguage, Languages } from '.';

function translocoInitFactory(accountRepo: AccountRepository, transloco: TranslocoService) {
  return async () => {
    try {
      await lastValueFrom(accountRepo.instance.initialized$);
      let lang = accountRepo.getLanguage();
      if (!lang) {
        // State has no language so we get value from Device
        lang = (await Device.getLanguageCode()).value.substring(0, 2);
        if (!Languages.includes(lang)) {
          lang = DefaultLanguage;
        }

        accountRepo.changeLanguage(lang);
      }

      transloco.setActiveLang(lang);
      await lastValueFrom(transloco.load(lang));
    } catch (error) {
      console.log(error);
    }
  };
}

export const translocoInitializer = provideAppInitializer(() => {
  const initializerFn = translocoInitFactory(inject(AccountRepository), inject(TranslocoService));
  return initializerFn();
});
